import React, { Ref } from 'react';
import { useTranslation } from 'react-i18next';
import { cn } from '@/utils';
import Modal from './Modal';

export interface DialogModalProps extends React.DialogHTMLAttributes<HTMLDialogElement> {
  children: React.ReactNode;
  modalRef?: Ref<HTMLDialogElement>;
  parentClassName?: string;
  dialogClassName?: string;
  parentElement?: 'div' | 'form';
  closeOnClickOutside?: boolean;
  onClickOutside?: () => void;
}

export default function DialogModal({
  children,
  closeOnClickOutside = false,
  dialogClassName,
  parentClassName,
  parentElement = 'form',
  onClickOutside,
  modalRef,
  ...props
}: DialogModalProps) {
  const { t } = useTranslation();
  const parentProps = { className: cn('modal-box space-y-4', parentClassName) };

  return (
    <Modal>
      <dialog ref={modalRef} {...props} className={cn('modal', dialogClassName)}>
        {parentElement === 'form' ? (
          <form method="dialog" {...parentProps}>
            {children}
          </form>
        ) : (
          <div {...parentProps}>{children}</div>
        )}
        {closeOnClickOutside && (
          <form method="dialog" className="modal-backdrop">
            <button onClick={onClickOutside} type="submit">
              {t('Close')}
            </button>
          </form>
        )}
      </dialog>
    </Modal>
  );
}
